import { getApiBaseUrl } from "./apiBase";

/** GET com formato=csv e download do arquivo (Content-Disposition). */
export async function downloadApiCsv(pathWithQuery) {
  const token = localStorage.getItem("accessToken");
  const isNgrok = getApiBaseUrl().includes("ngrok");
  const res = await fetch(`${getApiBaseUrl()}${pathWithQuery}`, {
    headers: {
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...(isNgrok ? { "ngrok-skip-browser-warning": "true" } : {}),
    },
  });
  if (res.status === 401) {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    window.location.href = "/";
    return;
  }
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.message || `HTTP ${res.status}`);
  }
  const blob = await res.blob();
  const disp = res.headers.get("Content-Disposition") || "";
  const m = disp.match(/filename="?([^";]+)"?/i);
  const filename = m ? m[1] : `export_${new Date().toISOString().slice(0, 10)}.csv`;
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(link.href);
}
